"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var placeholder_png_1 = __importDefault(require("./placeholder.png"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)({
    xs: {
        width: 16,
    },
    sm: {
        width: 24,
    },
    md: {
        width: 32,
    },
    lg: {
        width: 48,
    },
    xl: {
        width: 96,
    },
    xxl: {
        width: 128,
    },
    avatar: function (styles) { return (__assign(__assign({ borderRadius: '37.5%' }, styles), { '& img': {
            verticalAlign: 'top',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
        } })); },
});
var Avatar = function (_a) {
    var src = _a.src, name = _a.name, styles = _a.styles, size = _a.size, className = _a.className, onClick = _a.onClick;
    var classes = useStyles(styles);
    var img = (0, react_1.useMemo)(function () {
        return src ? src : placeholder_png_1.default;
    }, [src]);
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)(classes.avatar, size && classes[size], className) },
        react_1.default.createElement("img", { src: img, alt: name })));
};
Avatar.defaultProps = {
    size: 'md',
};
exports.default = Avatar;
//# sourceMappingURL=index.js.map